import { getScript } from '@/utils'
import { $ui } from '@/utils/ui'

export const getStripe = async () => {
  if (!window.Stripe) {
    await getScript('https://js.stripe.com/v3/')
    window.stripe = window.Stripe(
      $ui.isDev
        ? 'pk_test_vl0j4C49MHPIMc4bzjbTsD3w'
        : 'pk_live_47IOFNDnpidPnH0t2vYg8bUM')
  }
  return window.stripe
}
